/* ==========================================================================
   Nette Aufkleber – Auffrischung Herbst 2026
   Hereinfliegen, Parallaxe, Sale-Badges, Flug in den Warenkorb, „Passt dazu“.
   Kein Fremdcode, keine Bibliothek. Läuft auch, wenn Teile der Seite fehlen.
   ========================================================================== */
(function () {
  'use strict';

  var html = document.documentElement;
  var spaet = html.classList.contains('na-notausgang'); // Skript kam erst nach dem Notausgang
  html.classList.add('na-bereit');

  var ruhig = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (ruhig) html.classList.add('na-ruhig');

  // Vorschau-Elemente (Sale vor dem Start) nur im unveröffentlichten Theme zeigen
  try {
    if (window.Shopify && Shopify.theme && Shopify.theme.role && Shopify.theme.role !== 'main') {
      html.classList.add('na-vorschau-an');
    }
  } catch (e) { /* bleibt aus */ }

  /* ------------------------------------------------------------------------
     Hereinfliegen beim Scrollen
     Nur Elemente, die beim Laden noch unterhalb des Bildschirms liegen, werden
     erst versteckt. Was schon zu sehen ist, bleibt stehen (kein Flackern).
     ------------------------------------------------------------------------ */
  var beobachter = null;

  function markiere(el, klasse, verzug) {
    if (!el || el.__naMarkiert) return;
    el.__naMarkiert = true;
    var oben = el.getBoundingClientRect().top;
    if (spaet || ruhig || oben < window.innerHeight * 0.92) return;
    el.classList.add('na-reveal');
    if (klasse) el.classList.add(klasse);
    el.style.setProperty('--na-d', String(verzug || 0));
    if (beobachter) beobachter.observe(el);
  }

  function badgeBeobachten(el, verzug) {
    if (!el || el.__naBadge) return;
    el.__naBadge = true;
    el.style.setProperty('--na-d', String(verzug || 0));
    if (spaet || ruhig || !beobachter) { el.classList.add('na-in'); return; }
    beobachter.observe(el);
  }

  function sammeln(wurzel) {
    wurzel = wurzel || document;
    // Abschnittsüberschriften
    wurzel.querySelectorAll('.shopify-section h2:not(.na-hero__titel), .na-laufband__titel').forEach(function (h) {
      markiere(h, 'na-reveal--titel', 0);
    });
    // Produktkarten gestaffelt je Gruppe
    var gruppen = new Map();
    wurzel.querySelectorAll('product-card').forEach(function (karte) {
      var gruppe = karte.closest('.swiper-wrapper, ul, .grid, .shopify-section') || document.body;
      var i = gruppen.get(gruppe) || 0;
      gruppen.set(gruppe, i + 1);
      markiere(karte, null, (i % 4) * 110);
    });
    // Sale-Badges
    var b = 0;
    wurzel.querySelectorAll('[data-na-badge]').forEach(function (badge) {
      badgeBeobachten(badge, (b++ % 4) * 140 + 250);
    });
  }

  if ('IntersectionObserver' in window) {
    beobachter = new IntersectionObserver(function (eintraege) {
      eintraege.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('na-in');
        beobachter.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  function start() {
    sammeln(document);

    // Nachgeladene Inhalte (Warenkorb, Vorschläge, Endlos-Liste) ebenfalls versorgen
    var mo = new MutationObserver(function (liste) {
      liste.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-na-badge]')) badgeBeobachten(n, 0);
          if (n.querySelectorAll) {
            n.querySelectorAll('[data-na-badge]').forEach(function (bd) { badgeBeobachten(bd, 0); });
            if (n.querySelector && n.querySelector('product-card')) sammeln(n);
          }
        });
      });
      leereVorschlaegeVerstecken();
    });
    mo.observe(document.body, { childList: true, subtree: true });

    heroParallaxe();
    leereVorschlaegeVerstecken();
  }

  /* ------------------------------------------------------------------------
     Titelbild: Foto langsamer, Aufkleber schneller (Tiefe)
     ------------------------------------------------------------------------ */
  function heroParallaxe() {
    var hero = document.querySelector('[data-na-hero]');
    if (!hero || ruhig) return;
    var bild = hero.querySelector('[data-na-parallax]');
    var person = hero.querySelector('[data-na-person]');
    // Bildsprünge: 10 freigestellte Einzelbilder, Bild für Bild am Scrollrad (keine Überblendung)
    var sprungBox = hero.querySelector('[data-na-frames]');
    var sprungBilder = [];
    var sprungAktiv = -1;
    var sprungBereit = false;
    var sparen = navigator.connection && navigator.connection.saveData;
    if (sprungBox && person && !sparen) {
      var adressen = sprungBox.getAttribute('data-na-frames').split('|').filter(Boolean);
      var bilderLaden = function () {
        var fertig = 0;
        adressen.forEach(function (adresse) {
          var b = new Image();
          b.decoding = 'async';
          b.alt = '';
          b.className = 'na-hero__frame';
          b.onload = b.onerror = function () {
            fertig++;
            if (fertig === adressen.length) {
              // erst nach dem Einstiegs-Zoom des Fotos umschalten, sonst springt die Größe
              setTimeout(function () { sprungBereit = true; rechnen(); }, Math.max(0, 2600 - performance.now()));
            }
          };
          b.src = adresse;
          sprungBox.appendChild(b);
          sprungBilder.push(b);
        });
      };
      var bilderStart = function () { setTimeout(bilderLaden, 500); };
      if (document.readyState === 'complete') bilderStart(); else window.addEventListener('load', bilderStart);
    }
    var schweber = Array.prototype.slice.call(hero.querySelectorAll('[data-na-speed]'));
    var faktorBild = bild ? parseFloat(bild.getAttribute('data-na-parallax')) || 0.2 : 0;
    var laeuft = false;

    function rechnen() {
      laeuft = false;
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      var y = Math.max(0, -r.top);
      if (bild) bild.style.transform = 'translate3d(0,' + (y * faktorBild).toFixed(1) + 'px,0)';
      if (person) {
        // Person bleibt fast stehen und wächst leicht – sie kommt auf den Betrachter zu
        var anteil = Math.min(1, y / Math.max(1, r.height));
        person.style.transform = 'translate3d(0,' + (y * 0.06).toFixed(1) + 'px,0) scale(' + (1 + anteil * 0.09).toFixed(4) + ')';
      }
      if (sprungBereit && sprungBilder.length) {
        var p = Math.min(1, y / Math.max(1, r.height * 0.85));
        var k = Math.round(p * sprungBilder.length); // 0 = Foto, 1..10 = Einzelbilder
        if (k !== sprungAktiv) {
          sprungAktiv = k;
          sprungBilder.forEach(function (b, i) { b.classList.toggle('ist-an', i === k - 1); });
          person.classList.toggle('na-sprung', k > 0);
        }
      }
      schweber.forEach(function (s, i) {
        var v = parseFloat(s.getAttribute('data-na-speed')) || 0.4;
        s.style.setProperty('--py', (-y * v).toFixed(1) + 'px');
        s.style.setProperty('--pr', ((i % 2 ? 1 : -1) * y * 0.03).toFixed(2) + 'deg');
      });
    }
    window.addEventListener('scroll', function () {
      if (!laeuft) { laeuft = true; requestAnimationFrame(rechnen); }
    }, { passive: true });
    rechnen();
  }

  /* ------------------------------------------------------------------------
     „Passt dazu“: leeren Bereich nie zeigen
     ------------------------------------------------------------------------ */
  function leereVorschlaegeVerstecken() {
    document.querySelectorAll('product-recommendations[data-recommendation-area]').forEach(function (pr) {
      var hatEintraege = pr.querySelector('.product-recommendations__item');
      if (!hatEintraege && !pr.classList.contains('hidden')) pr.classList.add('hidden');
    });
  }

  /* ------------------------------------------------------------------------
     Flug in den Warenkorb
     ------------------------------------------------------------------------ */
  function warenkorbZiel() {
    var ziele = document.querySelectorAll('[data-cart-link], .header__icon--cart, a[href="/cart"]');
    for (var i = 0; i < ziele.length; i++) {
      var r = ziele[i].getBoundingClientRect();
      if (r.width > 0 && r.height > 0) return ziele[i];
    }
    return null;
  }

  function fliegen(quelleImg) {
    if (ruhig || !quelleImg || !quelleImg.getBoundingClientRect) return;
    var ziel = warenkorbZiel();
    if (!ziel) return;
    var a = quelleImg.getBoundingClientRect();
    var z = ziel.getBoundingClientRect();
    if (!a.width) return;
    var groesse = Math.min(140, a.width);
    var flieger = document.createElement('img');
    flieger.className = 'na-flieger';
    flieger.src = quelleImg.currentSrc || quelleImg.src;
    flieger.alt = '';
    flieger.style.width = groesse + 'px';
    flieger.style.height = groesse + 'px';
    flieger.style.left = (a.left + a.width / 2 - groesse / 2) + 'px';
    flieger.style.top = (a.top + a.height / 2 - groesse / 2) + 'px';
    document.body.appendChild(flieger);
    var dx = (z.left + z.width / 2) - (a.left + a.width / 2);
    var dy = (z.top + z.height / 2) - (a.top + a.height / 2);
    var anim = flieger.animate([
      { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
      { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - 120) + 'px) scale(.75) rotate(-25deg)', opacity: 1, offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(-60deg)', opacity: .6 }
    ], { duration: 850, easing: 'cubic-bezier(.45,.05,.55,.95)' });
    anim.onfinish = function () {
      flieger.remove();
      ziel.classList.remove('na-wackeln');
      void ziel.offsetWidth;
      ziel.classList.add('na-wackeln');
    };
  }

  function bildZu(element) {
    var karte = element.closest('product-card, .product-recommendations__item');
    if (karte) return karte.querySelector('img');
    var seite = document.querySelector('.product__media img, [class*="media-gallery"] img, .product img');
    return seite;
  }

  // Formular-Absenden (Karten und Produktseite) – nur beobachten, nie eingreifen
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches) return;
    if (f.matches('form.product-card__add-to-cart--form, form[action*="/cart/add"], product-form form')) {
      fliegen(bildZu(f));
    }
  }, true);

  /* ------------------------------------------------------------------------
     „Passt dazu“: einfache Aufkleber mit einem Klick hinzufügen
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (e) {
    var knopf = e.target.closest && e.target.closest('.na-passt-dazu-add');
    if (!knopf) return;
    e.preventDefault();
    e.stopPropagation();
    if (knopf.disabled) return;
    knopf.disabled = true;

    var drawer = document.querySelector('cart-drawer');
    var abschnitte = [];
    try {
      if (drawer && drawer.getSectionsToRender) abschnitte = drawer.getSectionsToRender().map(function (s) { return s.section; });
    } catch (err) { abschnitte = []; }

    fliegen(bildZu(knopf));

    var url = ((window.routes && routes.cart_add_url) || '/cart/add') + '.js';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(knopf.getAttribute('data-variant-id')), quantity: 1 }],
        sections: abschnitte,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (antwort) {
        if (antwort && antwort.status && antwort.status >= 400) throw new Error(antwort.description || 'Fehler');
        if (drawer && drawer.renderContents && antwort.sections) drawer.renderContents(antwort);
        if (typeof updateCartCounters === 'function') updateCartCounters();
        if (typeof updateFreeShipping === 'function') updateFreeShipping();
      })
      .catch(function () {
        knopf.disabled = false;
        knopf.textContent = 'Nochmal versuchen';
      });
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
